import { GoogleAuth } from "./Google/GoogleAuth";
import { TelegramAuthButton } from "./Telegram/TelegramAuthButton";
import "./index.css";

const AuthOptions = () => {
  return (
    <section className="auth-options-section">
      <TelegramAuthButton />
      <GoogleAuth />
    </section>
  );
};

export default AuthOptions;
